/* Rorilio · PDP Bálsamo PDRN : galerie, choix du pack (quantité 1/2/3 sur la variante unique), compte à rebours, date de livraison. Aucun effet hors des éléments data-rpd-*. */
(function () {
  function money(t) { return t || ''; }

  function initGallery(root) {
    var track = root.querySelector('[data-rpd-track]');
    if (!track || track.dataset.ready) return;
    track.dataset.ready = '1';
    var slides = track.children;
    var thumbs = root.querySelectorAll('[data-rpd-thumb]');
    function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function go(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function sync() {
      var i = current();
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        if (on && t.parentNode) {
          var p = t.parentNode;
          var l = t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2;
          p.scrollTo({ left: l, behavior: 'smooth' });
        }
      });
    }
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.rpdThumb, 10)); }); });
    var prev = root.querySelector('[data-rpd-prev]');
    var next = root.querySelector('[data-rpd-next]');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
    });
  }

  function initPacks(root) {
    var offer = root.querySelector('[data-rpd-offer]');
    if (!offer || offer.dataset.ready) return;
    offer.dataset.ready = '1';
    var qty = root.querySelector('[data-rpd-qty]');
    var btn = root.querySelector('[data-rpd-atc]');
    var label = root.querySelector('[data-rpd-atc-label]');
    function select(card) {
      offer.querySelectorAll('[data-rpd-pack]').forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-selected', on);
        var r = c.querySelector('input[type=radio]');
        if (r) r.checked = on;
      });
      if (qty) qty.value = card.dataset.qty || '1';
      if (btn) {
        var ok = card.dataset.available === 'true';
        btn.disabled = !ok;
        if (label) label.textContent = ok ? btn.dataset.label : btn.dataset.unavailable;
      }
    }
    offer.querySelectorAll('[data-rpd-pack]').forEach(function (card) {
      var r = card.querySelector('input[type=radio]');
      if (r) r.addEventListener('change', function () { if (r.checked) select(card); });
    });
  }


  /* Oferta 1+1 / 2+2 / 3+3 (bloc sy_offer) : l'option choisie règle la quantité du formulaire (2 / 4 / 6), débloque les regalos,
     et le bouton passe par RorilioPdrnCart.addPack (regalos en vraies lignes). Compte à rebours jusqu'à minuit heure de Mexico. */
  function initSyOffer(root) {
    var offer = root.querySelector('[data-rpd-syoffer]');
    if (!offer || offer.dataset.ready) return;
    offer.dataset.ready = '1';
    var qty = root.querySelector('[data-rpd-qty]');
    var btn = root.querySelector('[data-rpd-atc]');
    var label = root.querySelector('[data-rpd-atc-label]');
    function apply() {
      var r = offer.querySelector('input[type=radio]:checked');
      if (!r) return;
      var idx = parseInt(r.dataset.idx, 10) || 1;
      if (qty) qty.value = r.dataset.qty || '1';
      offer.querySelectorAll('.rpd-sy__gift').forEach(function (g) { g.classList.toggle('is-locked', idx < (parseInt(g.dataset.unlock, 10) || 1)); });
      if (btn) {
        var ok = r.dataset.available === 'true';
        btn.disabled = !ok;
        if (label) label.textContent = ok ? btn.dataset.label : btn.dataset.unavailable;
      }
    }
    offer.querySelectorAll('input[type=radio]').forEach(function (r) { r.addEventListener('change', apply); });
    apply();
    var out = offer.querySelector('[data-rpd-sytimer]');
    if (out) {
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        /* Mexique = UTC-6 toute l'année : minuit à Mexico = 06:00 UTC. */
        var now = Date.now(), d = new Date(now), end = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 6, 0, 0);
        if (end <= now) end += 86400000;
        var s = Math.floor((end - now) / 1000);
        out.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      };
      tick();
      setInterval(tick, 1000);
    }
    var form = btn && btn.form;
    if (!form) return;
    /* Capture sur la section : passe avant le gestionnaire de product-form. Sans le script panier, envoi classique. */
    root.addEventListener('submit', function (e) {
      if (e.target !== form || !window.RorilioPdrnCart) return;
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
      var q = parseInt(qty && qty.value, 10) || 1;
      var errWrap = root.querySelector('.product-form__error-message-wrapper'), errMsg = root.querySelector('.product-form__error-message');
      if (errWrap) errWrap.hidden = true;
      btn.classList.add('loading'); btn.setAttribute('aria-busy', 'true');
      var spin = btn.querySelector('.loading__spinner'); if (spin) spin.classList.remove('hidden');
      window.RorilioPdrnCart.addPack(q).then(function (state) {
        if (!window.RorilioPdrnCart.open(state)) window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }).catch(function (x) {
        if (errWrap && errMsg) { errMsg.textContent = (x && x.message) || 'No se pudo agregar al carrito.'; errWrap.hidden = false; }
      }).then(function () {
        btn.classList.remove('loading'); btn.removeAttribute('aria-busy');
        if (spin) spin.classList.add('hidden');
      });
    }, true);
  }

  function initDelivery(root) {
    root.querySelectorAll('[data-rpd-delivery]').forEach(function (el) {
      var days = parseInt(el.dataset.days, 10) || 9;
      var d = new Date();
      var added = 0;
      while (added < days) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) added++; }
      var txt;
      try { txt = d.toLocaleDateString('es-MX', { day: 'numeric', month: 'long' }); } catch (e) { txt = d.toDateString(); }
      var out = el.querySelector('[data-rpd-date]');
      if (out) out.textContent = txt;
    });
  }

  /* Compte à rebours : mode « end » = jusqu'à la date de fin de campagne (défaut) ; mode « visit » = N minutes par visite (sessionStorage si dispo). Bandeau masqué après la date de fin. Les prix ne changent jamais ici. */
  function initPromo(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var end = Date.parse(el.dataset.end || '');
    if (!isNaN(end) && Date.now() > end && !el.hasAttribute('data-design-mode')) { el.hidden = true; return; }
    var out = el.querySelector('[data-rpd-timer]');
    if (!out) return;
    var mins = parseInt(el.dataset.minutes, 10) || 45;
    var byEnd = el.dataset.mode !== 'visit' && !isNaN(end);
    function pad2(n) { return (n < 10 ? '0' : '') + n; }
    if (byEnd) {
      var tickEnd = function () {
        var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
        out.textContent = (d ? d + ' d ' : '') + pad2(h) + ':' + pad2(m) + ':' + pad2(sec);
      };
      tickEnd();
      setInterval(tickEnd, 1000);
      return;
    }
    var key = 'rpd-timer-' + (el.dataset.key || 'x');
    var deadline = 0;
    try { deadline = parseInt(sessionStorage.getItem(key), 10) || 0; } catch (e) {}
    if (!deadline || deadline < Date.now()) {
      deadline = Date.now() + mins * 60000;
      try { sessionStorage.setItem(key, String(deadline)); } catch (e) {}
    }
    if (!isNaN(end) && deadline > end) deadline = end;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var s = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      out.textContent = (h ? h + ':' + pad(m) : pad(m)) + ':' + pad(sec);
      if (s <= 0) {
        deadline = Date.now() + mins * 60000;
        if (!isNaN(end) && deadline > end) deadline = end;
        try { sessionStorage.setItem(key, String(deadline)); } catch (e) {}
      }
    }
    tick();
    setInterval(tick, 1000);
  }

  /* Carrousels génériques (data-rpd-scroller) : flèches + points ; « Ver más » des avis. */
  function initScroller(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var track = root.querySelector('[data-rpd-scroller-track]');
    if (!track) return;
    var items = track.children;
    var dots = root.querySelector('[data-rpd-scroller-dots]');
    function step() { return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth; }
    function idx() { return Math.round(track.scrollLeft / Math.max(1, step())); }
    function go(i) { i = Math.max(0, Math.min(items.length - 1, i)); track.scrollTo({ left: i * step(), behavior: 'smooth' }); }
    if (dots) {
      for (var k = 0; k < items.length; k++) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', String(k + 1)); (function (n) { b.addEventListener('click', function () { go(n); }); })(k); dots.appendChild(b); }
    }
    function sync() { if (!dots) return; var i = idx(); Array.prototype.forEach.call(dots.children, function (d, n) { d.classList.toggle('is-active', n === i); }); }
    var raf; track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    var p = root.querySelector('[data-rpd-scroller-prev]'), n = root.querySelector('[data-rpd-scroller-next]');
    if (p) p.addEventListener('click', function () { go(idx() - 1); });
    if (n) n.addEventListener('click', function () { go(idx() + 1); });
    sync();
  }
  function initReviews(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var btn = root.querySelector('[data-rpd-reviews-more]');
    if (btn) btn.addEventListener('click', function () { root.querySelectorAll('.rpd-rv__item.is-hidden').forEach(function (e) { e.classList.remove('is-hidden'); }); btn.parentNode.removeChild(btn); });
  }

  function init(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-rpd-scroller]').forEach(initScroller);
    s.querySelectorAll('[data-rpd-reviews]').forEach(initReviews);
    s.querySelectorAll('[data-rpd-main]').forEach(function (root) { initGallery(root); initPacks(root); initSyOffer(root); initDelivery(root); });
    s.querySelectorAll('[data-rpd-promo]').forEach(initPromo);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
